module.exports = __webpack_public_path__ + "img/kma-img-r-5ytz5i00A-unsplash.ca8f8b46.jpg";